import { confirm, init, loadForm, pay, validateForm } from '../../../../store/actions/register.action';
import { Subscription } from 'rxjs';
import {
  RegisterForm,
  RegisterFormPay,
  RegisterFormState,
  RegisterFormStatus,
  RegisterReceiptData,
} from '../../../../store/models/register.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';

import { PageState } from 'app/store/models/page.model';

import { openSnackbar, setBannerComponent } from 'app/store/actions/page.action';
import { DialogService } from 'app/shared/ui/dialog/dialog.service';
import { getIsAuthenticated } from 'app/store/selectors/user.selector';
import { IReducers } from '../../../../store/reducers';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
  currentStep = 2;
  confirmationToken: string = null;
  isEmailTaken = false;
  emailErrors: string[] = [];
  paymentErrors: any = null;
  confirmationErrorMessage: string;

  registerFormData: RegisterForm;
  registerFormPayData: RegisterFormPay;
  registerPaymentReceiptData: RegisterReceiptData;

  private paramsSubscribed: Subscription;

  constructor(
    private store: Store<PageState>,
    private registerStore: Store<IReducers>,
    private activeRoute: ActivatedRoute,
    private errorDialog: DialogService,
    private router: Router,
  ) {
    this.store.dispatch(setBannerComponent({ banner: 'Sign up' }));
    this.registerStore.dispatch(init());
    this.paramsSubscribed = this.activeRoute.queryParams.subscribe(
      (params: { [key: string]: any }) => {
        if (Object.keys(params).length === 0) {
          this.registerStore.dispatch(
            loadForm({
              data: {
                step: 1,
              },
            }),
          );
        }

        if (params.payment && params.payment === 'true') {
          this.registerStore.dispatch(
            loadForm({
              data: {
                step: 2,
                forceBilling: true,
              },
            }),
          );
        } else if (params.confirmation && params.confirmation === 'true') {
          this.registerStore.dispatch(
            loadForm({
              data: {
                step: 5,
              },
            }),
          );
        } else if (
          params.confirmation_token &&
          params.confirmation_token.length > 0
        ) {
          this.registerStore.dispatch(
            loadForm({
              data: {
                step: 5,
                confirmation_token: params.confirmation_token,
              },
            }),
          );
        }
      },
    );
  }

  onReceiptContinue(event) {
    this.switchStep(this.currentStep + 1);
  }

  onStepConfirm(token) {
    this.registerStore.dispatch(confirm({ token }));
  }

  onStepSubmit(data) {
    this.registerFormData = data;
    this.registerStore.dispatch(
      validateForm({
        data,
      }),
    );
  }

  onStepPay(data: RegisterFormPay) {
    const userName = localStorage.getItem('username');

    if (userName && userName.length > 0) {
      localStorage.removeItem('username');
      data.username = userName;
    }
    this.registerFormPayData = data;
    if (data.amount.indexOf('$') !== -1) {
      data.amount = data.amount.substr(1);
    }

    this.registerStore.dispatch(
      pay({
        userData: this.registerFormData || null,
        data,
      }),
    );
  }

  switchStep(step) {
    this.currentStep = step;
  }

  ngOnDestroy(): void {
    if (this.paramsSubscribed) {
      this.paramsSubscribed.unsubscribe();
    }
  }

  ngOnInit() {
    this.store
      .select(getIsAuthenticated)
      .subscribe((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          localStorage.setItem('comming_from', 'register');
          this.router.navigate(['/messages']);
        }
      });
    this.registerStore
      .select('register')
      .subscribe((state: RegisterFormState) => {
        this.confirmationToken = state.confirmation_token;
        this.registerFormData = state.data;
        this.registerFormPayData = state.payData;
        switch (state.status) {
          case RegisterFormStatus.REGISTER_STATE_READY:
          case RegisterFormStatus.REGISTER_STATE_VALID:
            this.switchStep(state.step);
            break;
          case RegisterFormStatus.REGISTER_STATE_INVALID:
            if (state.errors) {
              this.emailErrors = state.errors;
            }
            this.isEmailTaken = true;
            break;
          case RegisterFormStatus.REGISTER_STATE_PAYING:
            this.switchStep(3);
            break;
          case RegisterFormStatus.REGISTER_STATE_PAY_VALID:
            this.registerPaymentReceiptData = state.paymentReceipt;
            this.switchStep(4);
            break;
          case RegisterFormStatus.REGISTER_STATE_PAY_INVALID:
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message: state.errors.message.join('\n'),
                    type: 'error',
                  },
                },
              }),
            );
            this.switchStep(2);
            break;
          case RegisterFormStatus.REGISTER_STATE_CONFIRM_ERROR:
            this.confirmationErrorMessage = state.confirmationError;
            break;
        }
      });
  }
}
